import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative min-h-screen md:flex"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-800 text-gray-100 flex justify-end md:hidden" }, [
  /*#__PURE__*/_createVNode("button", { class: "mobile-menu-button p-4 focus:outline-none focus:bg-gray-700" }, [
    /*#__PURE__*/_createVNode("svg", {
      class: "h-5 w-5",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 6h16M4 12h16M4 18h16"
      })
    ])
  ])
], -1)
const _hoisted_3 = { class: "sidebar_wrapper -translate-x-full sidebar bg-white w-1/16 space-y-6 py-7 px-2 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out" }
const _hoisted_4 = { class: "block py-2.5 px-4 rounded transition duration-200 menu-nav" }
const _hoisted_5 = { class: "block py-2.5 px-4 rounded transition duration-200 menu-nav font-size-12" }
const _hoisted_6 = {
  class: "flex-1",
  style: {"overflow":"hidden"}
}
const _hoisted_7 = { class: "content-wrapper inset-y-0 flex items-center justify-between sm:static sm:inset-auto sm:ml-0 pl-8 pr-8 pt-8" }
const _hoisted_8 = { class: "flex items-base text-2xl font-bold text-gray-333" }
const _hoisted_9 = { class: "flex items-center justify-end sm:static sm:inset-auto sm:ml-6" }
const _hoisted_10 = { class: "block mt-4 lg:inline-block lg:mt-0 lg:ml-0 hover:text-gray-700" }
const _hoisted_11 = {
  href: "#",
  role: "button",
  class: "flex w-12 h-12 relative rounded-full justify-center items-center badge_wrapper"
}
const _hoisted_12 = { class: "dialog-profile absolute" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "top-bot" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "top-bot top-bot-border" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyButton = _resolveComponent("MyButton")
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Badges = _resolveComponent("Badges")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ToastApp = _resolveComponent("ToastApp")

  return (_ctx.isShowView)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("a", _hoisted_4, [
            _createVNode(_component_MyButton, {
              typeFnBtn: `${_ctx.nameCompany.label}-ele`,
              label: _ctx.nameCompany.label,
              paddingBottom: "18",
              isNav: true,
              fontWeight: _ctx.nameCompany.fontWeight,
              icon: _ctx.nameCompany.icon,
              fontSize: _ctx.nameCompany.fontSize,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.nameCompany)))
            }, null, 8, ["typeFnBtn", "label", "fontWeight", "icon", "fontSize"])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navMenu, (nav, index) => {
            return (_openBlock(), _createBlock("nav", { key: index }, [
              _createVNode("a", _hoisted_5, [
                _createVNode(_component_MyButton, {
                  class: ["menu-nav-item", _ctx.isActiveNavMenu(nav.path) ? 'active--nav' : ''],
                  label: nav.text,
                  onClick: ($event: any) => (_ctx.goToPage(nav))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock("span", {
                      class: "icon",
                      key: nav.text
                    }, [
                      _createVNode(_component_BaseIcon, {
                        name: nav?.icon
                      }, null, 8, ["name"])
                    ]))
                  ]),
                  _: 2
                }, 1032, ["label", "onClick", "class"])
              ])
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.backRouterPath)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: _ctx.backNavigation,
                    alt: "",
                    srcset: "",
                    class: "mr-4 cursor-pointer",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backRoute && _ctx.backRoute(...args)))
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.currentPage), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("li", _hoisted_10, [
                _createVNode("a", _hoisted_11, [
                  _createVNode("img", {
                    class: "w-8 h-8",
                    src: _ctx.Ring,
                    alt: "",
                    srcset: ""
                  }, null, 8, ["src"]),
                  _createVNode(_component_Badges, {
                    classAddition: "absolute flex right-0 top-0 rounded-full font-bold top right  p-0 m-0 text-white text-center ",
                    width: "4",
                    fontSize: "10px",
                    height: "4",
                    label: "9",
                    background: "bg-red-500"
                  })
                ])
              ]),
              _createVNode("li", {
                onClick: [
                  _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleToglePopupProfile && _ctx.handleToglePopupProfile(...args))),
                  _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                ],
                class: "block mt-4 ml-4 lg:inline-block lg:mt-0 lg:ml-4 hover:text-gray-700 relative cursor-pointer"
              }, [
                _createVNode(_component_Avatar, {
                  width: "40px",
                  height: "40px",
                  src: _ctx.profile.linkProfile
                }, null, 8, ["src"]),
                _withDirectives(_createVNode("div", {
                  onClick: [
                    _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                    _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleHiddenPopupProfile && _ctx.handleHiddenPopupProfile(...args)))
                  ],
                  class: "fixed top-0 left-0 w-screen h-screen z-50 cursor-default"
                }, null, 512), [
                  [_vShow, _ctx.isShowPopupProfile]
                ]),
                _withDirectives(_createVNode("ul", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _createVNode("li", {
                    onClick: [
                      _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                      _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    ],
                    class: "dialog-content cursor-pointer p-2 z-50"
                  }, _toDisplayString(_ctx.t('logout')), 1)
                ], 512), [
                  [_vShow, _ctx.isShowPopupProfile]
                ])
              ])
            ])
          ]),
          _createVNode(_component_router_view),
          _createVNode(_component_ToastApp)
        ])
      ]))
    : _createCommentVNode("", true)
}